import { BookingRequestComponent } from './der-tailormade-booking-request.component';

export * from './der-tailormade-booking-request.component';
export default BookingRequestComponent;

BookingRequestComponent.define('der-tailormade-booking-request');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-booking-request': BookingRequestComponent;
    }
}
